import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Inject, Injector, Directive, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class FsSkeletonBannerComponent {
    constructor(config) {
        this.config = config;
    }
}
FsSkeletonBannerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSkeletonBannerComponent, deps: [{ token: 'skeletonConfig' }], target: i0.ɵɵFactoryTarget.Component });
FsSkeletonBannerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsSkeletonBannerComponent, selector: "fs-skeleton-banner", ngImport: i0, template: "<div class=\"fs-skeleton-container fs-skeleton-banner\">\n  <div class=\"fs-skeleton-avatar\"></div>\n  <div class=\"skeleton-lines\">\n    <ng-container *ngFor=\"let lineWidth of config.pattern\">\n      <div class=\"fs-skeleton-line\" [ngStyle]=\"{ 'width.%': lineWidth }\"></div>\n    </ng-container>\n  </div>\n</div>\n", directives: [{ type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSkeletonBannerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-skeleton-banner',
                    templateUrl: './banner.component.html',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['skeletonConfig']
                }] }]; } });

class FsSkeletonFormComponent {
    constructor(config) {
        this.config = config;
    }
}
FsSkeletonFormComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSkeletonFormComponent, deps: [{ token: 'skeletonConfig' }], target: i0.ɵɵFactoryTarget.Component });
FsSkeletonFormComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsSkeletonFormComponent, selector: "fs-skeleton-form", ngImport: i0, template: "<div class=\"fs-skeleton-container fs-skelton-form\">\n  <ng-container *ngFor=\"let lineWidth of config.pattern\">\n    <div class=\"fs-skeleton-line\" [ngStyle]=\"{ 'width.%': lineWidth }\"></div>\n  </ng-container>\n  <div class=\"fs-skeleton-button\"></div>\n</div>\n", directives: [{ type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSkeletonFormComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-skeleton-form',
                    templateUrl: './form.component.html',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['skeletonConfig']
                }] }]; } });

class FsSkeletonContentComponent {
    constructor(config) {
        this.config = config;
    }
}
FsSkeletonContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSkeletonContentComponent, deps: [{ token: 'skeletonConfig' }], target: i0.ɵɵFactoryTarget.Component });
FsSkeletonContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsSkeletonContentComponent, selector: "fs-skeleton-content", ngImport: i0, template: "<div class=\"fs-skeleton-container fs-skeleton-content\">\n  <ng-container *ngFor=\"let lineWidth of config.pattern\">\n    <div class=\"fs-skeleton-line\" [ngStyle]=\"{ 'width.%': lineWidth }\"></div>\n  </ng-container>\n</div>\n", directives: [{ type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSkeletonContentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-skeleton-content',
                    templateUrl: './content.component.html',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['skeletonConfig']
                }] }]; } });

class FsSkeletonBaseDirective {
    constructor(_viewContainer, _componentFactoryResolver, templateRef) {
        this._viewContainer = _viewContainer;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._pattern = [];
        this._contentTemplateRef = null;
        this._contentViewRef = null;
        this._skeletonRef = null;
        this._componentFactory = null;
        this._contentTemplateRef = templateRef;
    }
    ngOnDestroy() {
        if (this._skeletonRef) {
            this._skeletonRef.destroy();
        }
    }
    _updateView() {
        if (this._context.$implicit) {
            if (!this._contentViewRef) {
                this._viewContainer.clear();
                if (this._skeletonRef) {
                    this._skeletonRef.destroy();
                }
                this._skeletonRef = null;
                if (this._contentTemplateRef) {
                    this._contentViewRef = this._viewContainer.createEmbeddedView(this._contentTemplateRef, this._context);
                }
            }
        }
        else {
            if (!this._skeletonRef) {
                this._viewContainer.clear();
                this._contentViewRef = null;
                if (!this._componentFactory) {
                    this._initComponent();
                }
                const injector = Injector.create({
                    providers: [
                        {
                            provide: 'skeletonConfig',
                            useValue: {
                                pattern: this._pattern,
                            }
                        }
                    ]
                });
                this._skeletonRef = this._viewContainer.createComponent(this._componentFactory, void 0, injector);
            }
        }
    }
    _initComponent() { }
}
FsSkeletonBaseDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSkeletonBaseDirective, deps: [{ token: i0.ViewContainerRef }, { token: i0.ComponentFactoryResolver }, { token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
FsSkeletonBaseDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsSkeletonBaseDirective, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSkeletonBaseDirective, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }, { type: i0.ComponentFactoryResolver }, { type: i0.TemplateRef }]; } });

class FsSkeletonContentDirective extends FsSkeletonBaseDirective {
    constructor(_viewContainer, _componentFactoryResolver, templateRef) {
        super(_viewContainer, _componentFactoryResolver, templateRef);
        this._viewContainer = _viewContainer;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._pattern = [100, 90, 80, 100];
        this._context = {
            $implicit: null,
            fsSkeleton: null,
        };
    }
    set fsSkeleton(condition) {
        this._context.$implicit = this._context.fsSkeleton = condition;
    }
    ngOnChanges(changes) {
        if (changes.fsSkeleton) {
            this._updateView();
        }
    }
    _initComponent() {
        this._componentFactory = this._componentFactoryResolver.resolveComponentFactory(FsSkeletonContentComponent);
    }
}
FsSkeletonContentDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSkeletonContentDirective, deps: [{ token: i0.ViewContainerRef }, { token: i0.ComponentFactoryResolver }, { token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
FsSkeletonContentDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsSkeletonContentDirective, selector: "[fsSkeleton]", inputs: { fsSkeleton: "fsSkeleton", _pattern: ["fsSkeletonPattern", "_pattern"] }, usesInheritance: true, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSkeletonContentDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsSkeleton]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }, { type: i0.ComponentFactoryResolver }, { type: i0.TemplateRef }]; }, propDecorators: { fsSkeleton: [{
                type: Input
            }], _pattern: [{
                type: Input,
                args: ['fsSkeletonPattern']
            }] } });

class FsSkeletonFormDirective extends FsSkeletonBaseDirective {
    constructor(_viewContainer, _componentFactoryResolver, templateRef) {
        super(_viewContainer, _componentFactoryResolver, templateRef);
        this._viewContainer = _viewContainer;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._pattern = [100, 100, 100];
        this._context = {
            $implicit: null,
            fsSkeletonForm: null,
        };
    }
    set fsSkeletonForm(condition) {
        this._context.$implicit = this._context.fsSkeletonForm = condition;
    }
    ngOnChanges(changes) {
        if (changes.fsSkeletonForm) {
            this._updateView();
        }
    }
    _initComponent() {
        this._componentFactory = this._componentFactoryResolver.resolveComponentFactory(FsSkeletonFormComponent);
    }
}
FsSkeletonFormDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSkeletonFormDirective, deps: [{ token: i0.ViewContainerRef }, { token: i0.ComponentFactoryResolver }, { token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
FsSkeletonFormDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsSkeletonFormDirective, selector: "[fsSkeletonForm]", inputs: { fsSkeletonForm: "fsSkeletonForm", _pattern: ["fsSkeletonFormLines", "_pattern"] }, usesInheritance: true, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSkeletonFormDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsSkeletonForm]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }, { type: i0.ComponentFactoryResolver }, { type: i0.TemplateRef }]; }, propDecorators: { fsSkeletonForm: [{
                type: Input
            }], _pattern: [{
                type: Input,
                args: ['fsSkeletonFormLines']
            }] } });

class FsSkeletonBannerDirective extends FsSkeletonBaseDirective {
    constructor(_viewContainer, _componentFactoryResolver, templateRef) {
        super(_viewContainer, _componentFactoryResolver, templateRef);
        this._viewContainer = _viewContainer;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._pattern = [100, 81];
        this._context = {
            $implicit: null,
            fsSkeletonBanner: null,
        };
    }
    set fsSkeletonBanner(condition) {
        this._context.$implicit = this._context.fsSkeletonBanner = condition;
        this._updateView();
    }
    ngOnChanges(changes) {
        if (changes.fsSkeletonBanner) {
            this._updateView();
        }
    }
    _initComponent() {
        this._componentFactory = this._componentFactoryResolver.resolveComponentFactory(FsSkeletonBannerComponent);
    }
}
FsSkeletonBannerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSkeletonBannerDirective, deps: [{ token: i0.ViewContainerRef }, { token: i0.ComponentFactoryResolver }, { token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
FsSkeletonBannerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsSkeletonBannerDirective, selector: "[fsSkeletonBanner]", inputs: { fsSkeletonBanner: "fsSkeletonBanner", _pattern: ["fsSkeletonBannerLines", "_pattern"] }, usesInheritance: true, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSkeletonBannerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsSkeletonBanner]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }, { type: i0.ComponentFactoryResolver }, { type: i0.TemplateRef }]; }, propDecorators: { fsSkeletonBanner: [{
                type: Input
            }], _pattern: [{
                type: Input,
                args: ['fsSkeletonBannerLines']
            }] } });

class FsSkeletonModule {
}
FsSkeletonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSkeletonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsSkeletonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSkeletonModule, declarations: [FsSkeletonBannerComponent,
        FsSkeletonFormComponent,
        FsSkeletonContentComponent,
        FsSkeletonContentDirective,
        FsSkeletonFormDirective,
        FsSkeletonBannerDirective], imports: [CommonModule], exports: [FsSkeletonContentDirective,
        FsSkeletonFormDirective,
        FsSkeletonBannerDirective] });
FsSkeletonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSkeletonModule, imports: [[
            CommonModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSkeletonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                    ],
                    exports: [
                        FsSkeletonContentDirective,
                        FsSkeletonFormDirective,
                        FsSkeletonBannerDirective,
                    ],
                    declarations: [
                        FsSkeletonBannerComponent,
                        FsSkeletonFormComponent,
                        FsSkeletonContentComponent,
                        FsSkeletonContentDirective,
                        FsSkeletonFormDirective,
                        FsSkeletonBannerDirective,
                    ],
                }]
        }] });

/*
 * Public API Surface of fs-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FsSkeletonBannerDirective, FsSkeletonContentDirective, FsSkeletonFormDirective, FsSkeletonModule };
